<div class="bottom-sheet">
  <div class="bottom-sheet__header">
    <custom-app-bar
      [title]="'no_stock.title' | translate"
      [hasCloseButton]="true"
      [hasSafeArea]="false"
      [closeButtonReturnToThePreviousPage]="false"
      (onClickCloseButton)="closeBottomSheet()"
    ></custom-app-bar>
  </div>

  <div class="bottom-sheet__content">
    <div class="header">
      <p class="header-text">
        {{ "no_stock.count" | translate: { quantity: products.length } }}
      </p>
    </div>

    <div class="product__list">
      <ep-product-list-tile
        *ngFor="let product of products"
        [product]="product"
        [hasAddToListButton]="false"
        [hasDeleteButton]="false"
        [hasAddToCartButton]="false"
      >
      </ep-product-list-tile>
    </div>

    <ng-container *ngIf="{value: similarProducts$ | async} as similarProducts">
      <div *ngIf="canDisplaySimilarProduct$ | async">
        <div class="header">
          <p class="header-text">
            {{ "no_stock.similar_products" | translate }}
          </p>
        </div>

        <div class="product__list">
          <ep-product-list-tile
                  *ngFor="let product of similarProducts.value"
                  [product]="product"
                  [hasAddToListButton]="false"
                  [hasDeleteButton]="false"
          >
          </ep-product-list-tile>
          <ng-container *ngIf="isSimilarProductsLoading$ | async">
            <ep-product-list-tile-skeleton
                    *ngFor="let i of [0,0,0]"
            >
            </ep-product-list-tile-skeleton>
          </ng-container>

        </div>
      </div>
    </ng-container>

    <div class="page__footer">
      <div class="buttons">
        <button customButton size="large" expand="full" [routerLink]="['/', routesNames.cartDetail ] | localize">
          {{'no_stock.go_to_cart' | translate}}
        </button>
        <button customButton appearance="ghost" size="large" expand="full" (click)="closeBottomSheet()">
          {{'no_stock.continue' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
